import {
    HANDLE_EQUITY_NOTES,
    HANDLE_CONSIGNMENT_BILLING_NOTES,
    HANDLE_CONSIGNMENT_ADD_NOTES,
    HANDLE_REPORT_USAGE_NOTES,
    HANDLE_SURGERY_NOTES,
    RESET_NOTES,
} from '../actions/constants';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

const initialState = {
    equityNotes: [],
    consignmentBillingNotes: [],
    consignmentAddNotes: [],
    reportUsageNotes: [],
    surgeryNotes: [],
};
const HeaderNotesReducer = (state = initialState, action) => {
    switch (action.type) {
        case RESET_NOTES:
            return {
                ...state,
                ...initialState,
            };
        case HANDLE_EQUITY_NOTES:
            return {
                ...state,
                equityNotes: action.payload,
            };
        case HANDLE_CONSIGNMENT_BILLING_NOTES:
            return {
                ...state,
                consignmentBillingNotes: action.payload,
            };
        case HANDLE_CONSIGNMENT_ADD_NOTES:
            return {
                ...state,
                consignmentAddNotes: action.payload,
            };
        case HANDLE_REPORT_USAGE_NOTES:
            return {
                ...state,
                reportUsageNotes: action.payload,
            };
        case HANDLE_SURGERY_NOTES:
            return {
                ...state,
                surgeryNotes: action.payload,
            };
        default: {
            return { ...state };
        }
    }
};

// export default HeaderNotesReducer;

export default persistReducer(
    {
        key: 'HeaderNoteKey',
        storage: storage,
    },
    HeaderNotesReducer
);
